const grupoVerify = ({ next, router, to, store }) => {
  let { grupoConteudo } = store.state;

  if (!grupoConteudo.id) {
    let redirectUrl = '';

    if (to.path) {
      redirectUrl = `?redirect-url=${to.path}`;
    }

    return router.push(`/prova/grupo-conteudo${redirectUrl}`);
  }

  return next();
};

export default grupoVerify;



// WEBPACK FOOTER //
// ./src/middleware/grupoVerify.js